<template>
  <div id="display-info"
       class="part">
    <template v-if="isEdit!=='display'">
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">H-index</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)"> {{data.hindex || '--'}}
          <ipub-icon v-if="data.hindexed"
                     type="iconAble"
                     class="success-color" />
        </div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">H-index URL</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">
          <a class="link-color"
             :href="data.hindexUrl"
             v-if="data.hindexUrl"> {{data.hindexUrl}}</a>
          <font v-else>--</font>
        </div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">
          <ipub-icon type="iconORCID"
                     style="color:#A6CE39"
                     class="fw-400" />
          ORCID
        </span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.orcid || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">ResearchGate Account</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.researchGate || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">Personal Homepage</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.website || '--'}}</div>
      </div>
      <div class="mar-b-12">
        <span class="ipub-block__span"
              style="width: 200px">Show Email</span>
        <div class="ipub-block__font"
             style="width:calc(100% - 300px)">{{data.displayEmail ? 'Yes' : 'No'}}</div>
      </div>
    </template>
    <template v-else>
      <ipub-form ref="display-form"
                 :model="form"
                 :rules="rules">
        <ipub-row :gutter="12">
          <ipub-col :span="2">
            <ipub-form-item prop="hindex"
                            label="H-index">
              <ipub-input placeholder="H-index"
                          number
                          v-model="form.hindex" />
            </ipub-form-item>
            <ipub-form-item prop="hindexed">
              <ipub-radio :checked="form.hindexed"
                          @change="()=>{form.hindexed = !form.hindexed}"
                          label="Choose to show H-index" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="10">
            <ipub-form-item prop='hindexUrl'
                            label="H-Index URL">
              <ipub-input placeholder="H-Index URL"
                          v-model.trim="form.hindexUrl" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20">
          <ipub-col :span="4">
            <ipub-form-item prop='orcid'
                            label="ORCID">
              <div class="ipub-p1 mar-b-10"
                   slot="label">
                <ipub-icon class="ipub-p2"
                           style="font-size:14px;color:#a6ce39"
                           type="iconORCID" />
                ORCID
                <ipub-tooltip placement="bottomRight"
                              type="dark">
                  <div slot="title">
                    Like 0000-0001-2345-6789 or 0000123455556789
                  </div>
                  <ipub-icon class="ipub-p1"
                             style="font-size:14px;"
                             type="iconInfo" />
                </ipub-tooltip>
              </div>
              <ipub-input placeholder="ORCID"
                          v-model.trim="form.orcid" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop='researchGate'
                            label="ReasearchGate Account">
              <ipub-input placeholder="ReasearchGate Account"
                          v-model.trim="form.researchGate" />
            </ipub-form-item>
          </ipub-col>
          <ipub-col :span="4">
            <ipub-form-item prop='website'
                            label="Website">
              <ipub-input placeholder="Website"
                          v-model.trim="form.website" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
        <ipub-row :gutter="20"
                  class="mar-b-20">
          <ipub-col :span="6">
            <ipub-form-item prop="displayEmail">
              <ipub-radio :checked="form.displayEmail"
                          @change="form.displayEmail=!form.displayEmail"
                          label="Show email on website" />
            </ipub-form-item>
          </ipub-col>
        </ipub-row>
      </ipub-form>
      <div class="btns">
        <ipub-button plain
                     style="width:180px"
                     type="primary"
                     @click="back">Cancel</ipub-button>
        <ipub-button style="width:180px;margin-left:20px"
                     type="primary"
                     @click="save">Save</ipub-button>
      </div>
    </template>
  </div>
</template>

<script>
import person from '@/api/person'
import { mapGetters } from 'vuex'
import check from '@/utils/check'
export default {
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    isEdit: {
      type: String,
      default: ''
    },
  },
  data () {
    return {
      // isEdit: false,
      showRank: false,
      showDegree: false,
      form: {
        hindexed: false,
        displayEmail: false,
        affiliations: [''],
        reviewJournals: ['']
      },
      rules: {},
      sectionList: [],
      academicList: [],
      degreesList: [],
      journalList: [],
      eidtObj: {
        index: '',
        identity: false,
        sort: false
      }
    }
  },
  computed: {
    ...mapGetters({
      language: 'getLanguage'
    })

  },
  watch: {
    isEdit (val) {
      if (val === 'display') {
        this.form = JSON.parse(JSON.stringify(this.data))
      }
    },
  },
  mounted () {
    this.getRules()
  },
  methods: {
    async save () {
      const flag = this.$refs['display-form'].validate()
      // if (
      //   !this.form.degreesIdList ||
      //   (this.form.degreesIdList && this.form.degreesIdList.length === 0)
      // ) {
      //   this.$message.error({
      //     title: 'Error',
      //     content: 'Degree / Credential cannot be empty!'
      //   })
      //   return
      // }
      if (flag) {
        await person.editDisplay(this.form.id, this.form)
        this.$message.success({
          title: 'Success',
          content: 'This User has been saved! Display'
        })
        this.$emit('confirm')
      }
    },

    back () {
      this.$emit('cancel')
    },
    getRules () {
      this.rules = {
        hindexUrl: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'H-index Url'
          }
        ],
        website: [
          {
            type: 'website',
            message: this.LANGUAGE[this.language].enterCorrent + 'Website'
          }
        ],
        orcid: [
          {
            fun: check.orcid,
            message: `Encourage input ORCID`
          }
        ],
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.part {
  padding: 4px 16px;
}
</style>
